import Base from "@/models/Base";

export default class Report extends Base {
  constructor() {
    super();
  }
  // 健康档案列表
  static async getReportList(params, callback) {
    let data = await this.get({
      url: '/mini/health/index',
      data: params
    })
    this.success(callback, data);
  }

  // 健康档案（报告）详情
  static async getReports(params, callback) {
    let data = await this.get({
      url: '/mini/health/report',
      data: params
    })
    this.success(callback, data);
  }
 // 骨健康评估
 static async getReportsGu(params, callback) {
  let data = await this.get({
    url: '/mini/health/report/bone',
    data: params
  })
  this.success(callback, data);
}
   // 肠动力对比
   static async getContrast(params, callback) {
    let data = await this.post({
      url: '/mini/health/report/contrast',
      data: params
    })
    this.success(callback, data);
  }
}
